import { BaseModel } from '../../global/models';
import { UserModelRefDisplayName } from '../user';

export interface ActivityLog extends BaseModel {
  ref: ActivityLogRefCollection;
  user: UserModelRefDisplayName;
  type: ActivityLogType;
  payload: PropertyPayload | CommentPayload | ReportIncidentPayload;
  from: UpdatedByFrom;
}


export interface ActivityLogRefCollection {
  collection: String;
  id: String;
}

export interface PropertyPayload {
  changes: [{
    property: String;
    old: any;
    new: any;
  }];
}

export interface CommentPayload {
  comment: string;
}

export interface ReportIncidentPayload {
  message: string;
}

export interface UpdatedBy {
  id: string;
  displayName: string;
  from: UpdatedByFrom;
}


export enum UpdatedByFrom {
  APP = 'app',
  ADMIN = 'admin',
  SERVER = 'server'
}

export enum ActivityLogType {
  PROPERTY_CHANGED = 'property_changed',
  CREATED = 'created',
  COMMENT = 'comment',
  REPORT_INCIDENT = 'report_incident'
}
